import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/material';
import { NAV } from '@raas/shared/src/shared-config-global';
import { useSettingsContext } from '@raas/shared/src/components/minimals/settings';
import { useLocales } from '@raas/shared/src/locales';

export default function Footer() {
  const theme = useTheme();
  const { themeLayout } = useSettingsContext();
  const { translate } = useLocales();

  const isNavMini = themeLayout === 'mini';

  const linkAttributes = [
    {
      href: 'https://www.kontrol.tech/terms-and-conditions/',
      label: translate('common.legalNotice'),
    },
    {
      href: 'https://www.kontrol.tech/legal/',
      label: translate('common.impressum'),
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        ml: 'auto',
        mt: 'auto',
        width: `calc(100% - ${(isNavMini ? NAV.W_DASHBOARD_MINI : NAV.W_DASHBOARD) + 1}px)`,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Container>
        <Stack
          display="flex"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={{ xs: 1.5, sm: 2.5, lg: 3.5 }}
        >
          <Typography variant="body2" color="text.secondary" component="div">
            {`${translate('common.copyright')} ©`}
            <Link sx={{ px: '4px' }} color="inherit" href="https://www.kontrol.tech/">
              {translate('common.kontrolTitle')}
            </Link>
            {new Date().getFullYear()}
          </Typography>
          <Typography
            variant="body1"
            component="div"
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 3 }}
          >
            {linkAttributes.map((item, index) => (
              <Link
                key={`footer-link-${index}`}
                color="inherit"
                href={item.href}
                target="_blank"
                rel="noreferrer"
              >
                {item.label}
              </Link>
            ))}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
